import _slicedToArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { jsx } from 'react/jsx-runtime';
import { useContext, createContext, useState, useEffect, useMemo } from 'react';
var FullScreenMenuContext = /*#__PURE__*/createContext(null);

var FullScreenMenuProvider = function FullScreenMenuProvider(_ref) {
  var children = _ref.children,
      isFullScreenEnabled = _ref.isFullScreenEnabled,
      isMenuOpen = _ref.isMenuOpen,
      setIsMenuOpen = _ref.setIsMenuOpen;

  var _useState = useState(isFullScreenEnabled || false),
      _useState2 = _slicedToArray(_useState, 2),
      isMenuFullScreenEnabled = _useState2[0],
      setIsMenuFullScreenEnabled = _useState2[1];

  useEffect(function () {
    if (isFullScreenEnabled !== undefined) {
      setIsMenuFullScreenEnabled(isFullScreenEnabled);
    }
  }, [isFullScreenEnabled]);
  var value = useMemo(function () {
    return {
      isMenuFullScreenEnabled: isMenuFullScreenEnabled,
      setIsMenuFullScreenEnabled: setIsMenuFullScreenEnabled,
      isMenuOpen: isMenuOpen,
      setIsMenuOpen: setIsMenuOpen
    };
  }, [isMenuFullScreenEnabled, setIsMenuFullScreenEnabled, isMenuOpen, setIsMenuOpen]);
  return jsx(FullScreenMenuContext.Provider, {
    value: value,
    children: children
  });
};

var useFullScreenDropdownMenu = function useFullScreenDropdownMenu() {
  var context = useContext(FullScreenMenuContext);

  if (context === null) {
    throw new Error('useFullScreenMenu must be used within a menu DropdownMenu.Root');
  }

  return context;
};

export { FullScreenMenuProvider, useFullScreenDropdownMenu };